// Lib
import { createSelector } from 'reselect';

// Utils
import { hasSeen } from '../../../common/users/userEducationUtil';

// Selectors
import { getCurrentUserEducation, isGuestSelector } from '../../user/currentUserSelector';
import { selectIsMobileAppMode, selectIsScreenLandscape, selectWindowFillsScreen } from '../platformSelector';

// Constants
import { ONBOARDING_EDUCATION_CODES } from '../../../common/users/userEducationConstants';

/**
 * Only allow mobile landscape mode if the user has completed onboarding.
 */
export const selectIsMobileLandscapeModeAllowed = createSelector(
    isGuestSelector,
    getCurrentUserEducation,
    (isGuest, currentUserEducation) => {
        if (isGuest) return true;

        // If the user hasn't completed onboarding, don't allow landscape mode
        if (hasSeen(currentUserEducation, ONBOARDING_EDUCATION_CODES.DESKTOP_ONBOARDING)) return true;

        return false;
    },
);

/**
 * Whether the mobile landscape (read-only) mode is showing.
 * It is a phone-held-sideways posture, so it needs the mobile workspace to fill the screen: a landscape-shaped
 * Stage Manager window, a Split View pane or an unfolded phone is not a phone held sideways.
 */
export const selectIsMobileLandscapeModeActive = createSelector(
    selectIsMobileAppMode,
    selectIsMobileLandscapeModeAllowed,
    selectIsScreenLandscape,
    selectWindowFillsScreen,
    (isMobileAppMode, isLandscapeAllowed, isScreenLandscape, windowFillsScreen) =>
        isMobileAppMode && isLandscapeAllowed && isScreenLandscape && windowFillsScreen,
);
